module.exports = __webpack_public_path__ + "55babffc06c649ea7a03d2266025e4c2.woff";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-light.woff
// module id = 1065
// module chunks = 0